<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "commondescr",
      key: "id",
      url: {
        get: `/admin/system/meeting/room`,
        add: `/admin/system/meeting/room`,
        edit: "/admin/system/meeting/room",
      },
      id: "",
      typeId: "",
      items: [
        { label: "新增会议室", type: "header" },
        {
          label: "会议室名称",
          name: "meetingName",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "楼宇",
          name: "building",
          value: "",
          width: "400px",
          type: "select",
          dropList: [],
          onChange: this.getFloor,
          rules: [
            { required: true, message: "楼宇不能为空", trigger: "blur", type: "number" },
          ],
        },
        {
          label: "楼层",
          name: "floor",
          value: "",
          width: "400px",
          type: "select",
          dropList: [],
          rules: [
            { required: true, message: "楼层不能为空", trigger: "blur", type: "number" },
          ],
        },
        {
          label: "房间号",
          name: "room",
          value: "",
          width: "400px",
          type: "input",
          rules: [{ required: true, message: "房间号不能为空", trigger: "blur" }],
        },
        {
          label: "性质",
          name: "liableState",
          value: 2,
          width: "400px",
          type: "select",
          dropList: [
            {
              value: 1,
              name: "需要审核",
            },
            {
              value: 2,
              name: "无需审核",
            },
          ],
          onChange: this.onChangeTransport,
        },
        {
          label: "负责人",
          width: "400px",
          name: "liablePersonId",
          value: "",
          type: "select",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
      ],
      forms: {
        workType: 1,
      },
    };
  },
  props: ["onCancel", "ids", "actions"],
  mounted() { },
  created() {
    if (this.actions == "edit") {
      this.id = this.ids;
      this.handleSearch();
    }
    this.getBuilding();
    this.loaduserData();
    if (this.actions != 'edit') {
      this.onChangeTransport(2);
    }
  },
  methods: {
    async handleSearch() {
      let res = await $utils.api.load(`/admin/system/meeting/room/${this.ids}`);
      try {
        if (res) {
          this.getFloor(res.data.building);
          this.forms = res.data;
          this.onChangeTransport(res.data.liableState)
        }
      } catch (e) {
        console.log(e);
      }
    },
    onChangeTransport(val) {
      if (val == 1) {
        this.items[this.getItemIndex("liablePersonId")].type = "select";
      }
      if (val == 2) {
        this.items[this.getItemIndex("liablePersonId")].type = "kong";
      }
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/user/listAll", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "liablePersonId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    async getBuilding() {
      let d = {};
      let res = await $utils.api.load("admin/system/building/list", d, "get");
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.buildingName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "building") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async getFloor(e) {
      let d = {
        buildingId: e,
      };
      let res = await $utils.api.load("admin/system/floor/list", d, "get");
      if (res.code == 200) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.floorName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "floor") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    handleSubmit() {
      let q = this.forms;
      this.$refs.form.validate((valid) => {
        this.sloading = true;
        $utils.api
          .load(`/admin/system/meeting/room`, q, this.actions == "edit" ? "PUT" : "POST")
          .then((res) => {
            this.sloading = false;
            if (res.status) {
              $utils.toast.success("保存成功");
              this.$emit("onCancel");
              $utils.url.go(0);
            }
          })
          .catch((e) => {
            this.sloading = false;
            $utils.toast.error("保存异常" + e.message);
          });
      });
    },
  },
};
</script>
